/**
 * `AW7` — el borde de escritura de participantes, disponible para el árbol.
 *
 * Mismo patrón que `contexto-borde-escritura.tsx` y por la misma razón de fondo:
 * la pantalla de alta lo necesita y está a un nivel de la raíz, así que la
 * alternativa es plomería por props a través del montaje. Hay una segunda razón
 * y es la que importa: **inyectado, el borde se puede reemplazar por un doble.**
 * La pantalla se ejerce en `pruebas/aw7-alta.test.tsx` contra un doble en memoria,
 * sin base, sin red y sin el módulo real — y eso sólo es posible si el borde
 * entra por afuera. Un `crearBordeParticipantesHttp()` llamado adentro del
 * componente haría que la única forma de probarlo fuera interceptar `fetch`.
 */

import { createContext, useContext } from "react"
import type { BordeParticipantes } from "./borde-participantes.ts"

/**
 * Sin valor por defecto, igual que la configuración y el borde de escritura de
 * documentos.
 *
 * Un doble por defecto acá haría que un componente montado fuera del proveedor
 * anduviera igual, escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeParticipantes = createContext<BordeParticipantes | null>(null)

export const ProveedorBordeParticipantes = ContextoBordeParticipantes.Provider

export function useBordeParticipantes(): BordeParticipantes {
  const borde = useContext(ContextoBordeParticipantes)
  if (borde === null) {
    throw new Error(
      "useBordeParticipantes() se llamó fuera de <ProveedorBordeParticipantes>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
